import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NodeAPIEntityService } from './../services/node.entity.service';
// import * as jsonwebtoken from 'jwa';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Observable } from 'rxjs';
import { DipStateService } from '../services/dip-state-service.service';

@Component({
    selector: 'together-page-content-dynamic',
    templateUrl: './dip.jwt-redirector.component.html',
    styleUrls: ['./dip.jwt-redirector.component.scss'],
    providers: [NodeAPIEntityService],
    standalone: false
})
export class TogetherAuctionDIPJWTRedirectorComponent implements OnInit {

  jwtHelper = new JwtHelperService();

  _isLoading: boolean = true;
  _notifications: Array<object> = [];

  constructor(private router: Router, private route: ActivatedRoute, private entity: NodeAPIEntityService, private state: DipStateService) { }

  _setErrorNotifications(notifications) {
    this._notifications = notifications;
  }

  _handleDeletedNotification(notification_iteration) {
    delete this._notifications[notification_iteration];
  }

  addNotification(title) {
    this._notifications.push({ text: title });
  }

  /**
   * Stores the params in state.
   *
   * @param {any} params
   * @memberof TogetherAuctionDIPJWTRedirectorComponent
   */
  storeState(params) {
    const state = {
      caseId: params.case_id,
      stageName: 'tad_stage_login_recap',
      propertyType: params.property_type,
      isDipJourney: params.is_dip,
    };
    this.initLocalStorage(state).subscribe(() => { });
  }

  _decodeValidJWT(jwt) {
    try {
      const decoded_token = this.jwtHelper.decodeToken(jwt);
      // Add case id to state so it can be validated on navigation to the recap
      this.state.caseId.next(decoded_token.case_id);
      this.storeState(decoded_token);
      this.router.navigate(['dip',
        'tad_stage_login_recap',
        decoded_token.case_id,
        decoded_token.property_type,
        decoded_token.is_dip]);
    } catch (JSONParseError) {
      this.state.loginFailed = true;
      this.router.navigate(['dip', 'tad_stage_login']); // Prevent forgeries, etc.
    }
  }

  // Make sure we don't break retrieval
  initLocalStorage(params: object) {
    return new Observable((reqObs) => {
      window.sessionStorage.setItem('dipDetails', JSON.stringify(params));
      reqObs.next(true);
    });
  }

  _handleJWT(jwt) {
    this.entity.verifyJWT(jwt)
      .subscribe(
        (success) => {
          this._decodeValidJWT(jwt);
          this._isLoading = false;
        },
        (error) => {
          this.state.loginFailed = true;
          this.router.navigate(['dip', 'tad_stage_login']);
        },
      );
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this._handleJWT(params.jwt);
    });
  }

}
